import { createSlice } from "@reduxjs/toolkit";
import getPackage from "@custom/rtk-apis/billing/getBilling";

interface PackageItem {
  _id: string;
  _rev: string;
  type: string;
  packageName: string;
  servicesIncluded: string[];
  packagePricing: string;
  hospitalId: string;
  createdAt: string;
}

interface PackageResponse {
  status: string;
  data: PackageItem[];
}

interface PackageState {
  status: string;
  result: PackageResponse | null;
  loading: boolean;
  error: string;
}

const initialState: PackageState = {
  status: "",
  result: null,
  loading: false,
  error: ""
};

const getPackageSlice = createSlice({
  name: "getPackageSlice",
  initialState,
  reducers: {
    closeModal(state) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPackage.pending, (state) => {
        state.loading = true;
        state.status = 'pending';
      })
      .addCase(getPackage.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload;
      })
      .addCase(getPackage.rejected, (state, action) => {
        state.result = null;
        state.loading = false;
        state.status = 'failed';
        state.error = action.error?.message || "Failed to fetch package data";
      });
  },
});

export default getPackageSlice.reducer;
export const { closeModal } = getPackageSlice.actions;
